"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATIONS_SET_DATA = exports.ORGANIZATIONS_SET_IDS = void 0;
const const_1 = require("../../const");
exports.ORGANIZATIONS_SET_IDS = `${const_1.PREFIX_ENRICH}ORGANIZATIONS_SET_IDS`;
exports.ORGANIZATIONS_SET_DATA = `${const_1.PREFIX_ENRICH}ORGANIZATIONS_SET_DATA`;
